if (!customElements.get('review-summary-popup')) {
  class ReviewSummaryPopup extends HTMLElement {
    connectedCallback() {
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return;
      }

      this.dialog = this.querySelector('.review-summary-popup__dialog');
      this.inner = this.querySelector('.review-summary-popup__inner');
      this.closeButtons = this.querySelectorAll('[data-rs-close]');
      this.viewAll = this.querySelector('[data-rs-view-all]');
      this.handleKeydown = this.handleKeydown.bind(this);
      this.reposition = this.reposition.bind(this);
      this.trigger = null;

      this.closeButtons.forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      if (this.viewAll) {
        this.viewAll.addEventListener('click', () => this.scrollToReviews());
      }

      document.querySelectorAll('[data-review-summary-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.open(trigger);
        });
        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.open(trigger);
          }
        });
      });
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleKeydown);
      window.removeEventListener('resize', this.reposition);
      window.removeEventListener('scroll', this.reposition, true);
    }

    open(trigger) {
      this.trigger = trigger || document.querySelector('[data-review-summary-open]');
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.handleKeydown);
      window.addEventListener('resize', this.reposition);
      window.addEventListener('scroll', this.reposition, true);
      requestAnimationFrame(() => {
        this.reposition();
        const closeBtn = this.querySelector('.review-summary-popup__close');
        if (closeBtn) closeBtn.focus();
      });
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.handleKeydown);
      window.removeEventListener('resize', this.reposition);
      window.removeEventListener('scroll', this.reposition, true);
    }

    getCaretTarget(trigger) {
      return (
        trigger.querySelector('[data-rs-caret-target]') ||
        trigger.querySelector('.junip-product-summary-review-count') ||
        trigger
      );
    }

    reposition() {
      if (!this.dialog || !this.classList.contains('is-open')) return;

      const trigger = this.trigger || document.querySelector('[data-review-summary-open]');
      if (!trigger) return;

      const label =
        trigger.querySelector('.junip-product-summary-review-count') || trigger;
      const caretTarget = this.getCaretTarget(trigger);
      const labelRect = label.getBoundingClientRect();
      const caretRect = caretTarget.getBoundingClientRect();
      const margin = 16;
      const caretHeight = 10;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const dialogWidth = Math.min(400, viewportWidth - margin * 2);
      const isDesktop = viewportWidth >= 768;

      let left = labelRect.left;
      if (isDesktop) {
        const infoCol = trigger.closest('.product__info-wrapper');
        if (infoCol) {
          const paddingLeft = parseFloat(window.getComputedStyle(infoCol).paddingLeft) || 0;
          left = infoCol.getBoundingClientRect().left + paddingLeft;
        } else {
          left = trigger.getBoundingClientRect().left;
        }
      }
      left = Math.max(margin, Math.min(left, viewportWidth - dialogWidth - margin));

      let top = Math.max(labelRect.bottom, caretRect.bottom) + caretHeight;
      if (isDesktop) top = 185.203;
      this.dialog.style.width = `${dialogWidth}px`;
      this.dialog.style.left = `${left}px`;
      this.dialog.style.top = `${top}px`;

      const caretLeft = isDesktop ? 130.257813 : 115.257813;
      this.dialog.style.setProperty('--caret-left', `${caretLeft}px`);

      if (this.inner) {
        this.inner.style.maxHeight = `${Math.max(180, viewportHeight - top - margin)}px`;
      }
    }

    handleKeydown(event) {
      if (event.key === 'Escape') this.close();
    }

    scrollToReviews() {
      const targetSelector = this.viewAll && this.viewAll.getAttribute('data-scroll-target');
      const target = targetSelector ? document.querySelector(targetSelector) : null;
      this.close();
      if (target) {
        requestAnimationFrame(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }
  }

  customElements.define('review-summary-popup', ReviewSummaryPopup);
}
